import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response, RequestOptions, Headers} from '@angular/http';
import { environment } from '../../../environments/environment';
// import * as $ from 'jquery';
declare var $ : any;
import swal from 'sweetalert2';

@Component({
	selector: 'app-acknowledge-report',
	templateUrl: './acknowledge-report.component.html',
	styleUrls: ['./acknowledge-report.component.css']
})
export class AcknowledgeReportComponent implements OnInit {

	url = environment.url
	acknowledgeReportForm : FormGroup;
	query : any = null;
	report_data : any = null;
	lr_forms : any = null;
	lr_forms_account : any = null;
	lr_forms_sto : any = null;
	total_weight : any = null;
	total_freight : any = null;


	constructor( private http : Http) { }

	ngOnInit() {
		
		this.acknowledgeReportForm = new FormGroup({
			"date_range" : new FormControl(null, Validators.required),
			"invoice_by" : new FormControl(null, Validators.required),
			"ack_type" : new FormControl(null, Validators.required)
		})
		
	};

	process(){
		console.log(this.acknowledgeReportForm.value);

		const headers = new Headers();
		const options = new RequestOptions({ headers: headers });

		this.query = this.acknowledgeReportForm.value;

		if (this.query.invoice_by == "By S.T.O"){
			this.query.invoice_by = "sto_number"
			console.log(this.query);

			const path = this.url + '/reports/lr/' + this.query.invoice_by;
			this.http.post(path, this.query, options)
			.subscribe(res=>{
				this.report_data = res.json();
				console.log(this.report_data)
				this.lr_forms_sto = this.report_data.data
				this.total_weight = this.report_data.weight_total
				this.total_freight = this.report_data.freight_total
				this.lr_forms = null
				this.lr_forms_account = null
			});
		}
		else if(this.query.invoice_by == "By On_Account"){
			this.query.invoice_by = "on_account"
			console.log(this.query);

			const path = this.url + '/reports/lr/' + this.query.invoice_by;
			this.http.post(path, this.query, options)
			.subscribe(res=>{
				this.report_data = res.json();
				console.log(this.report_data)
				this.lr_forms_account = this.report_data.data
				this.lr_forms = null
				this.lr_forms_sto = null
				this.total_weight = this.report_data.weight_total
				this.total_freight = this.report_data.freight_total
			});
		}
		else{
			console.log(this.query);
			this.http.post(this.url + '/reports/lr', this.query, options)
			.subscribe(res=>{
				this.report_data = res.json();
				console.log(this.report_data)
				this.lr_forms = this.report_data.data
				this.lr_forms_account = null
				this.lr_forms_sto = null
				this.total_weight = this.report_data.weight_total
				this.total_freight = this.report_data.freight_total
			});
		}
	
	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/reports/acknowledge-report/acknowledge-report.component.ts